import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {VetineoApiResponse} from "../models/vetineo-api-response.model";
import {map} from "rxjs/operators";
import {ApiService} from "./api.service";
import {CommonUtils} from "../utils/common";
import {DataGridServiceInterface} from "./data-grid-service.interface";
import {
  UserCarePlanVisitTypeItemDgSearchResults
} from "../models/datagrid-search-results/user-care-plan-visit-type-item.dg-search-results.model";
import {UserCarePlanVetineoVisitTypeBundle} from "../models/user-care-plan-vetineo-visit-type-bundle.model";

/**
 * Serwis warstwy danych obsługujący powiązania (Pakiety/Bundle) pomiędzy
 * aktywnymi Planami Opieki (Abonamentami) pacjenta a zdefiniowanymi Typami Wizyt.
 * Ogranicza się do operacji odczytu w celu zasilania widoków tabelarycznych (DataGrid),
 * pozwalając na weryfikację uprawnień rezerwacyjnych pacjentów.
 */
@Injectable({
  providedIn: 'root'
})
export class UserCarePlanVisitTypeService implements DataGridServiceInterface<Observable<UserCarePlanVisitTypeItemDgSearchResults>> {

  constructor(private apiService: ApiService, public commonUtils: CommonUtils) {
  }

  /**
   * Pobiera paginowaną listę zmapowanych typów wizyt wchodzących w skład
   * aktywnych planów opieki użytkowników.
   *
   * @param limit Maksymalna liczba rekordów na stronę.
   * @param offset Przesunięcie wyników względem początku zbioru.
   * @param sortOrder Kierunek sortowania (np. 'ASC', 'DESC').
   * @param orderBy Nazwa kolumny, według której aplikowane jest sortowanie.
   * @param showDeletedObjects Flaga decydująca o widoczności usuniętych mapowań.
   * @returns Observable emitujący ustandaryzowany obiekt wyników dla komponentu DataGrid.
   */
  getResults(limit: number, offset: number, sortOrder: string, orderBy: string, showDeletedObjects: boolean = false): Observable<UserCarePlanVisitTypeItemDgSearchResults> {
    return this.apiService.get<VetineoApiResponse>(`/dashboard/user-care-plan-visit-types/${showDeletedObjects}/${limit}/${offset}/${sortOrder}/${orderBy}`, {}).pipe(map(vetineoApiResponse => {
      if (vetineoApiResponse.ok) {
        return new UserCarePlanVisitTypeItemDgSearchResults(vetineoApiResponse.response.total, this.commonUtils.bestTypedArrayCopyEver(new UserCarePlanVetineoVisitTypeBundle(), [], vetineoApiResponse.response.results), vetineoApiResponse.response.csrfToken);

      } else {
        return undefined;
      }
    }));
  }

  /**
   * Wykonuje filtrowanie i wyszukiwanie powiązań typów wizyt z planami opieki
   * na podstawie zaawansowanych kryteriów.
   *
   * @param limit Rozmiar strony.
   * @param offset Przesunięcie.
   * @param searchFieldsData Mapa zawierająca zdefiniowane filtry wyszukiwania.
   * @param sortOrder Kierunek sortowania.
   * @param orderBy Nazwa kolumny sortującej.
   * @param showDeletedObjects Flaga widoczności usuniętych rekordów.
   * @returns Observable emitujący przefiltrowaną listę powiązań dla DataGrid.
   */
  searchForResults(limit: number, offset: number, searchFieldsData: Map<string, string>, sortOrder: string, orderBy: string, showDeletedObjects: boolean = false): Observable<UserCarePlanVisitTypeItemDgSearchResults> {
    const data = {
      limit: limit,
      offset: offset,
      searchFieldsData: this.commonUtils.mapToSearchFieldList(searchFieldsData),
      sortOrder: sortOrder,
      orderBy: orderBy,
      showDeletedObjects: showDeletedObjects
    }
    return this.apiService.post<VetineoApiResponse>(`/dashboard/user-care-plan-visit-types/search`, data).pipe(map(vetineoApiResponse => {
      if (vetineoApiResponse.ok) {
        console.log(vetineoApiResponse.response.results);
        return new UserCarePlanVisitTypeItemDgSearchResults(vetineoApiResponse.response.total, this.commonUtils.bestTypedArrayCopyEver(new UserCarePlanVetineoVisitTypeBundle(), [], vetineoApiResponse.response.results), vetineoApiResponse.response.csrfToken);
      } else {
        return undefined;
      }
    }));
  }

}
